import { useTranslations } from '@vocab/react';
import { Secondary, Stack, Strong, Text } from 'braid-design-system';

import translations from './.vocab';
import { ProfileInsightsIndicator } from './ProfileInsightsIndicator/ProfileInsightsIndicator';

export const ViewsSection = ({
  viewCount,
  searchImpressionCount,
}: {
  viewCount: number;
  searchImpressionCount: number;
}) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="small">
      <Text size="xsmall">
        <Strong>
          <Secondary>{t('Last 90 days')}</Secondary>
        </Strong>{' '}
        <Secondary>{t('(updated daily)')}</Secondary>
      </Text>
      <Stack space="small">
        <ProfileInsightsIndicator
          text={t('Search appearances')}
          count={searchImpressionCount}
          tooltipText={t(
            'The number of times your profile appeared in a search result to an employer.',
          )}
        />

        <ProfileInsightsIndicator
          text={t('Profile views')}
          count={viewCount}
          tooltipText={t(
            'The number of times an employer viewed your profile.',
          )}
        />
      </Stack>
    </Stack>
  );
};
